// extracted by mini-css-extract-plugin
module.exports = {"container":"Category_container__kAjVQ","richContent":"Category_richContent__5zwJv","content":"Category_content__lOldo"};